import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditSessionNotification = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Session Notification'
      fields={fields}
      apiPath={`admin/session_notifications/${props.params.sessionNotificationId}`}
      successRedirectPath='/write-now/session_notifications'
      buildMenuItems={menuItems}
    />
  )
}

export default EditSessionNotification
